module.exports = __webpack_public_path__ + "img/Grapefruit.bf33a75f.svg";